"use client";

import { Slider } from "@ui/slider";
import { type ComponentProps } from "react";
import { useRange } from "../hooks/useRange";

export default function RangeSlider({
  min,
  max,
  value,
  onChange,
  formatter = (value: number) => value.toString(),
}: Omit<ComponentProps<typeof Slider>, "onChange"> & {
  onChange: (values: number[]) => void;
  formatter?: (value: number) => string;
}) {
  const { internalValues, onChangeValue } = useRange(value);

  return (
    <>
      <div className="flex justify-between pb-4">
        {internalValues?.map((internalValue) => (
          <span key={internalValue}>{formatter(Math.ceil(internalValue))}</span>
        ))}
      </div>
      <Slider
        min={min}
        max={max}
        value={internalValues}
        onValueChange={onChangeValue}
        onValueCommit={onChange}
        minStepsBetweenThumbs={1}
      />
    </>
  );
}
